import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'underscore';

import {Chip, withStyles, withTheme} from '@material-ui/core';
import ErrorOutline from '@material-ui/icons/ErrorOutline';

import ServiceAnnouncementDialog from './ServiceAnnouncementDialog';

const styles = (theme) => ({
  container: {
    position: 'absolute',
    width: '100%',
    zIndex: 10,
    display: 'flex',
    justifyContent: 'center',
  },
  chip: {
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '1rem',
    backgroundColor: theme.palette.warning.light,
    maxWidth: 'calc(100% - 32px)',
    '&:hover': {
      backgroundColor: theme.palette.warning.main,
    },
    '&:focus': {
      backgroundColor: theme.palette.warning.main,
    },
  },
  icon: {
    color: theme.palette.text.primary,
  },
});

class ServiceAnnouncementsAlert extends React.Component {

  static propTypes = {
    announcements: PropTypes.array,
    paddingTop: PropTypes.string,
    timezone: PropTypes.string,

    classes: PropTypes.object.isRequired,
  }

  state = {
    open: false,
  }

  handleOpen = () => {
    this.setState({open: true});
  }

  handleClose = () => {
    this.setState({open: false});
  }

  render() {
    const {announcements, classes, paddingTop} = this.props;
    if (announcements.length === 0) return null;

    const now = moment.utc();
    const currentAnnouncements = _.filter(announcements,
      (announcement) => now.isBetween(announcement.startTime, announcement.endTime, 'minute', '[]')
    );
    if (currentAnnouncements.length === 0) return null;

    const label = (
      currentAnnouncements.length === 1 ?
      currentAnnouncements[0].title :
      'Service Announcements'
    );
    return (
      <div className={classes.container} style={{paddingTop}}>
        <Chip
          icon={<ErrorOutline className={classes.icon} />}
          label={label}
          className={classes.chip}
          onClick={this.handleOpen}
        />
        <ServiceAnnouncementDialog
          open={this.state.open}
          handleClose={this.handleClose}
          announcements={currentAnnouncements}
        />
      </div>
    );
  }
}

export default withTheme(withStyles(styles)(ServiceAnnouncementsAlert));



// WEBPACK FOOTER //
// ./src/ondemand/components/ServiceAnnouncementsAlert/ServiceAnnouncementsAlert.js